import letrusAPI from 'APIs/letrusAPI/axiosInstance';

export interface TrackEventRequest {
  DeliveryStreamName: string;
  Record: {
    Data: string; // JSON encoded with base64
  };
}

export function trackEventsService(data: TrackEventRequest) {
  return letrusAPI(
    `${process.env.REACT_APP_PROD_CLICKSTREAM_COLLECTOR_URL}/api/clickstream`,
    {
      method: 'post',
      data,
      headers: {
        'x-api-key': process.env.REACT_APP_PROD_CLICKSTREAM_X_API_KEY,
      },
      withCredentials: false,
    },
  )
    .then((response) => response)
    .catch(() => console.log('Clickstream error'));
}
